import type { QueryClient } from '@tanstack/react-query';
import type { ContentObjectList } from 'models';
import type { InfiniteData } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import {
  getContentObjectsInfiniteQueryKey,
  getJournalFeedInfiniteQueryKey,
  getPinnedFeedInfiniteQueryKey,
  getProgramFeedInfiniteQueryKey,
  getRegularFeedInfiniteQueryKey,
} from 'features/feed/queries/keys';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { getContentObjectIdSafe } from 'features/feed/utils';

type UpdateBookmarkInFeedsParams = {
  id: string;
  isBookmarked: boolean;
  queryClient: QueryClient;
};

/**
 * @deprecated Introduced as part of the #87353 feed refactor to manually patch the React Query cache
 * after each mutation. This ad-hoc cache-patching approach needs a better long-term solution.
 */
export const updateBookmarkInFeeds = ({ id, isBookmarked, queryClient }: UpdateBookmarkInFeedsParams) => {
  const queryKeys = [
    getContentObjectsInfiniteQueryKey({}),
    getRegularFeedInfiniteQueryKey({}),
    getJournalFeedInfiniteQueryKey({}),
    getPinnedFeedInfiniteQueryKey({}),
    getProgramFeedInfiniteQueryKey({}),
  ];

  for (const queryKey of queryKeys) {
    queryClient.setQueriesData({ queryKey }, (oldData?: InfiniteData<ContentObjectList[]>) => {
      if (!oldData) {
        return oldData;
      }

      return {
        ...oldData,
        pages: oldData.pages.map((page) =>
          page.map((item: ContentObjectList) =>
            getContentObjectIdSafe(item) === id ? { ...item, bookmarked: isBookmarked } : item,
          ),
        ),
      };
    });
  }
};
